import { render, staticRenderFns } from "./ProductPackageSection.vue?vue&type=template&id=508485a0&scoped=true&"
import script from "./ProductPackageSection.vue?vue&type=script&lang=js&"
export * from "./ProductPackageSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductPackageSection.vue?vue&type=style&index=0&id=508485a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508485a0",
  null
  
)

export default component.exports